import type { SearchCriteria } from '../../api/api-clients';

export const profileKeys = {
  all: () => ['profiles'] as const,
  me: () => [...profileKeys.all(), 'me'] as const,
  views: () => [...profileKeys.all(), 'views'] as const,
} as const;

export const connectionKeys = {
  all: () => ['connections'] as const,
  mine: () => [...connectionKeys.all(), 'mine'] as const,
} as const;

export const explorerKeys = {
  all: () => ['explorer'] as const,
  searches: () => [...explorerKeys.all(), 'search'] as const,
  search: (criteria: SearchCriteria | undefined) =>
    [...explorerKeys.searches(), criteria] as const,
  details: () => [...explorerKeys.all(), 'detail'] as const,
  detail: (id: string | undefined) => [...explorerKeys.details(), id] as const,
} as const;

export const messageKeys = {
  all: () => ['messages'] as const,
  conversations: () => [...messageKeys.all(), 'conversations'] as const,
  conversation: (withId: string | undefined) =>
    [...messageKeys.all(), 'conversation', withId] as const,
} as const;

export const verificationKeys = {
  all: () => ['verification'] as const,
  mine: () => [...verificationKeys.all(), 'mine'] as const,
} as const;

export const paymentKeys = {
  all: () => ['payment'] as const,
  mine: () => [...paymentKeys.all(), 'mine'] as const,
} as const;

export const notificationPreferencesKeys = {
  all: () => ['notification-preferences'] as const,
  forProfile: (profileId: string | undefined) =>
    [...notificationPreferencesKeys.all(), profileId] as const,
} as const;
